import { useCallback } from "react";

import { hexHtmlToString } from "@hsl/core/utils/hexHtmlToString";

import useFundPageStore from "../store/store";

function useTranslation() {
    const translations = useFundPageStore((store) => store.translations);

    return useCallback(
        (str: string) => {
            if (translations[str]) {
                return {
                    translated: true,
                    result: hexHtmlToString(translations[str]!),
                };
            } else {
                return {
                    translated: false,
                    result: str,
                };
            }
        },
        [translations],
    );
}

export default useTranslation;

export const Translate = ({ children }: { children: string }) => {
    const showTranslations = useFundPageStore(
        (store) => store.config.showTranslations,
    );
    const T = useTranslation();
    if (showTranslations) {
        const { translated, result } = T(children);
        if (translated) {
            return <span className="bg-green-100">{result}</span>;
        } else {
            return <span className="bg-red-100">{result}</span>;
        }
    }
    return <>{T(children).result}</>;
};
